import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";

//Actions
import { getAsset, getAssetSubtype, getSubUser, getDriver, getUnit, resetEntitySelector, getAssetTypes } from './redux/slice';
import { syncEntitiesSetEntity } from 'Redux/actions';

//Components
import { Modal, ModalBody, ModalFooter, Button, Chip } from "@gpstrackit/react-controls";
import CustomSelect from 'Components/Select';
const EntitySelector = ({ }) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const {
        openModal,
        type,
        accountId,
        entities: entitiesList
    } = useSelector(state => state.syncEntitiesSelectorRedux);

    const [entities, setEntities] = useState([]);

    const closeModal = () => {
        dispatch(resetEntitySelector());
        dispatch(syncEntitiesSetEntity({ type: type, entity: entities }));
    }

    const getAccountsForSelect = (input, callback) => {
        if (!input) {
            callback([]);
            return;
        }

        const typeHandlers = {
            assets: getAsset,
            asset_subtypes: getAssetSubtype,
            subusers: getSubUser,
            drivers: getDriver,
            units: getUnit,
            asset_types: getAssetTypes
        };

        const handler = typeHandlers[type];

        if (handler) {
            handler(input, accountId)
                .then(callback)
                .catch(() => callback([]));
        } else {
            callback([]);
        }
    }

    useEffect(() => {
        if (openModal && entitiesList.length) {
            setEntities([...entitiesList])
        }
    }, [openModal])

    return (
        <Modal
            open={openModal}
            title={`${messages['sync_entities_title']} - Select ${messages[`sync_entities_${type}`] || type}`}
            handleClose={closeModal}
            position="right"
            loading={false}
            size="small"
        >
            <ModalBody style={{ height: '81vh' }}>
                <div style={{ padding: '0 10px', }}>
                    <CustomSelect
                        async
                        value={null}
                        onChange={(item) => {
                            if (item) {
                                let currentEntities = entities;
                                let existing = currentEntities.some(e => e?.id === item?.id);
                                if (!existing) {
                                    currentEntities.push(item);
                                    setEntities([...currentEntities]);
                                }
                            }

                        }}
                        label={messages[`sync_entities_${type}`] || type}
                        placeholder={messages[`sync_entities_${type}`] || type}
                        loadOptions={getAccountsForSelect}
                        getOptionLabel={e => e.label}
                        getOptionValue={e => e.id}
                        isClearable
                        menuPlacement="bottom"
                    />
                    <div>
                        {
                            entities.map((item, index) => {
                                return (
                                    <div key={item.id} style={{ marginTop: 5 }}>
                                        <Chip
                                            label={item?.label || ''}
                                            key={item?.id}
                                            handleDelete={() => {
                                                let currentEntities = entities
                                                currentEntities.splice(index, 1);
                                                setEntities([...currentEntities]);
                                            }}
                                        />
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <div>
                    <Button
                        className="btn btn-cancel"
                        onClick={(e) => {
                            e.preventDefault();
                            dispatch(resetEntitySelector());
                        }}
                    >
                        {messages['common_back']}
                    </Button>
                    <Button
                        onClick={(e) => {
                            e.preventDefault();
                            closeModal();
                        }}
                        className="btn-dark-blue"
                        disabled={false}
                    >
                        {messages['select']}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}

export default EntitySelector;